export const TIER_LIMITS = {
  free: {
    maxContacts: 15,
    occasionTypes: ['birthday'] as string[],
    aiMessagesPerMonth: 5,
    whatsappReminders: false,
    relationshipTimeline: false,
    aiVoiceLearning: false,
    healthNudges: false,
    annualReview: false,
    customLeadTimePerOccasion: false,
    dearestlyIntegration: false,
  },
  plus: {
    maxContacts: null,
    occasionTypes: 'all' as const,
    aiMessagesPerMonth: null,
    whatsappReminders: true,
    relationshipTimeline: true,
    aiVoiceLearning: true,
    healthNudges: true,
    annualReview: true,
    customLeadTimePerOccasion: true,
    dearestlyIntegration: true,
  },
  family: {
    maxContacts: null,
    occasionTypes: 'all' as const,
    aiMessagesPerMonth: null,
    whatsappReminders: true,
    relationshipTimeline: true,
    aiVoiceLearning: true,
    healthNudges: true,
    annualReview: true,
    customLeadTimePerOccasion: true,
    dearestlyIntegration: true,
  },
  teams: {
    maxContacts: null,
    occasionTypes: 'all' as const,
    aiMessagesPerMonth: null,
    whatsappReminders: true,
    relationshipTimeline: true,
    aiVoiceLearning: true,
    healthNudges: true,
    annualReview: true,
    customLeadTimePerOccasion: true,
    dearestlyIntegration: true,
  },
} as const;

export type SubscriptionTier = keyof typeof TIER_LIMITS;
export type TierFeature = keyof typeof TIER_LIMITS['plus'];
